/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, ViewChild} from '@angular/core';
import {PopoverDirective} from 'ngx-bootstrap/popover';
import template from './retail-product-list-filters.component.html';

@Component({
  standalone: false,
  selector: 'adn-retail-product-list-filters',
  template
})
export class RetailProductListFiltersComponent {
  @Input() list: any;

  @ViewChild('merchantPopoverTrigger', {read: PopoverDirective}) merchantPopoverDir: PopoverDirective;
  @ViewChild('brandPopoverTrigger', {read: PopoverDirective}) brandPopoverDir: PopoverDirective;
  @ViewChild('colourPopoverTrigger', {read: PopoverDirective}) colourPopoverDir: PopoverDirective;

  applyFilter(type: string): void {
    this.list?.makeRetailProductQuery?.(type);
    this.merchantPopoverDir?.hide();
    this.brandPopoverDir?.hide();
    this.colourPopoverDir?.hide();
  }

  clearFilter(type: string): void {
    this.list?.makeRetailProductQuery?.(type, true);
  }

  merchantLabel(): string {
    const merchant = this.list?.merchant;
    const guide = this.list?.merchantGuide?.[merchant];
    if (merchant && guide) {
      return guide.uiTitle || guide.title || guide.link;
    }
    return 'Merchant Filter';
  }
}
